@if (isOpen) {
<!-- Backdrop -->
<div
  (click)="onBackdropClick($event)"
  (keydown.enter)="onBackdropClick($event)"
  tabindex="0"
  animate.enter="hv-backdrop-enter"
  animate.leave="hv-backdrop-leave"
  class="hv-modal-backdrop fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-md"
  [style.zIndex]="zIndex()"
  [ngClass]="backdropPaddingClasses()"
>
  <!-- Modal Panel -->
  <div
    animate.enter="hv-modal-enter"
    class="hv-modal-panel relative bg-background shadow-2xl border border-border flex flex-col overflow-hidden"
    [ngClass]="[modalSizeClasses(), isMobile() ? 'rounded-none' : 'rounded-xl']"
    role="dialog"
    aria-modal="true"
  >
    <!-- Fixed Header - Always Visible -->
    <div
      class="flex-shrink-0 bg-gradient from-surface-low to-surface border-b border-border sticky top-0 z-10"
    >
      <div
        class="flex items-center justify-between"
        [ngClass]="[modalPaddingClasses(), 'py-4']"
      >
        <!-- Title Section -->
        <div class="flex items-center gap-3 flex-1 min-w-0">
          @if (icon()) {
          <div
            class="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-primary-low-contrast text-primary"
          >
            <lucide-icon [name]="icon()" class="w-5 h-5" />
          </div>
          }
          <div class="min-w-0 flex-1">
            <h2
              class="font-semibold text-primary leading-tight"
              [ngClass]="isMobile() ? 'text-lg' : 'text-xl'"
            >
              {{ title() }}
            </h2>
            @if (subtitle()) {
            <p class="text-sm text-text mt-0.5 line-clamp-1">
              {{ subtitle() }}
            </p>
            }
          </div>
        </div>

        <!-- Close Button -->
        <app-button
          (click)="close()"
          variant="ghost"
          size="sm"
          [iconOnly]="true"
          shape="circle"
          icon="X"
          class="flex-shrink-0 ml-4"
          aria-label="Close modal"
        />
      </div>
    </div>

    <!-- Scrollable Content Area -->
    <div
      class="flex-1 overflow-y-auto py-6 min-h-0 bg-background"
      [ngClass]="modalPaddingClasses()"
    >
      <!-- Slot for structured content -->
      <ng-content select="[slot=content]"></ng-content>
      <!-- Default content projection -->
      <ng-content></ng-content>
    </div>

    <!-- Fixed Action Bar - Only shown if actions exist -->
    @if (hasActions()) {
    <div
      class="flex-shrink-0 bg-surface-low backdrop-blur-sm border-t border-border py-4 sticky bottom-0"
      [ngClass]="modalPaddingClasses()"
    >
      <div
        class="flex items-center gap-3"
        [ngClass]="isMobile() ? 'flex-col-reverse' : 'justify-between'"
      >
        <!-- Secondary Actions (Left side on desktop, bottom on mobile) -->
        <div
          class="flex items-center gap-2"
          [ngClass]="isMobile() ? 'w-full' : ''"
        >
          <ng-content select="[slot=secondary-actions]"></ng-content>
        </div>

        <!-- Primary Actions (Right side on desktop, top on mobile) -->
        <div
          class="flex items-center gap-3"
          [ngClass]="isMobile() ? 'w-full flex-col' : 'ml-auto'"
        >
          <ng-content select="[slot=actions]"></ng-content>
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
